<template>
    <div class="slate__loading__animation">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" class="icon__loading__svg">
            <g :style="fillColor">
                <path
                    d="M8.16,138.48A99.6,99.6,0,0,0,49,185.78l5.8-14.07a84.94,84.94,0,0,1-.27-143.23l-5.83-14A100.06,100.06,0,0,0,8.16,138.48Z"></path>
                <path
                    d="M199.54,85.9A100.13,100.13,0,0,0,76.29,3l5.83,14A85,85,0,0,1,184.38,85.9Z"></path>
                <path
                    d="M138.94,192.39a100,100,0,0,0,60.34-76.6H184.07A84.86,84.86,0,0,1,82.43,183.1l-5.8,14.07A99.6,99.6,0,0,0,138.94,192.39Z"></path>
            </g>
        </svg>
    </div>
</template>

<script>
    export default {
        name: 'LoadingSpinner',
        props: {
            negative: {
                type: Boolean,
                default: false,
            },
        },
        data: function () {
            let fillColor;

            // This should be in the DLS
            if (this.negative) {
                fillColor = 'fill: rgba( 255, 255, 255, 0.8 ) !important;';
            } else {
                fillColor = 'fill: rgba( 0, 0, 0, 0.8 ) !important;';
            }
            return {
                fillColor,
            };
        },
    };
</script>
